import { Minus, Plus } from "lucide-react";

import { Chip } from "@/components/strategy/Chip";

export const FORMAT_OPTIONS = [
    "Short Video",
    "Carousel",
    "Static Image",
    "Text Post",
    "Live/Audio",
];

function Stepper({ label, value, onChange, min = 0, max = 10, testIdBase }) {
    const dec = () => onChange(Math.max(min, value - 1));
    const inc = () => onChange(Math.min(max, value + 1));
    return (
        <div
            className="flex flex-col gap-2"
            data-testid={`${testIdBase}-wrap`}
        >
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8A93A6]">
                {label}
            </span>
            <div className="inline-flex items-center gap-2 rounded-xl border border-[#1F2A40] bg-[#111726] px-2 py-1">
                <button
                    type="button"
                    onClick={dec}
                    disabled={value <= min}
                    data-testid={`${testIdBase}-dec`}
                    className="inline-flex h-7 w-7 items-center justify-center rounded-md text-[#8A93A6] transition-colors hover:bg-[#1A2235] hover:text-[#E8ECF5] disabled:cursor-not-allowed disabled:opacity-40"
                >
                    <Minus className="h-3.5 w-3.5" />
                </button>
                <span
                    className="min-w-[2ch] text-center font-mono text-sm font-semibold tabular-nums text-[#E8ECF5]"
                    data-testid={`${testIdBase}-value`}
                >
                    {value}
                </span>
                <button
                    type="button"
                    onClick={inc}
                    disabled={value >= max}
                    data-testid={`${testIdBase}-inc`}
                    className="inline-flex h-7 w-7 items-center justify-center rounded-md text-[#8A93A6] transition-colors hover:bg-[#1A2235] hover:text-[#00F5D4] disabled:cursor-not-allowed disabled:opacity-40"
                >
                    <Plus className="h-3.5 w-3.5" />
                </button>
            </div>
        </div>
    );
}

export default function Step4Frequency({ form, updateField, toggleArrayField }) {
    const setFreq = (key, val) =>
        updateField("frequency", { ...form.frequency, [key]: val });

    return (
        <div
            className="flex flex-col gap-7"
            data-testid="strategy-step-4"
        >
            <div className="flex flex-col gap-2">
                <h3 className="text-xl font-medium text-[#E8ECF5]">
                    How often, and in what shape?
                </h3>
                <p className="font-mono text-[11px] italic text-[#8A93A6]">
                    Dial your realistic cadence; Pulse will spread the mix
                    across weeks.
                </p>
            </div>

            <div className="flex flex-col gap-3">
                <label className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8A93A6]">
                    posting frequency
                </label>
                <div className="flex flex-wrap items-end gap-5">
                    <Stepper
                        label="reels / day"
                        value={form.frequency.reels_per_day}
                        onChange={(v) => setFreq("reels_per_day", v)}
                        max={10}
                        testIdBase="strategy-freq-reels"
                    />
                    <Stepper
                        label="stories / day"
                        value={form.frequency.stories_per_day}
                        onChange={(v) => setFreq("stories_per_day", v)}
                        max={20}
                        testIdBase="strategy-freq-stories"
                    />
                    <Stepper
                        label="posts / day"
                        value={form.frequency.posts_per_day}
                        onChange={(v) => setFreq("posts_per_day", v)}
                        max={10}
                        testIdBase="strategy-freq-posts"
                    />
                </div>
            </div>

            <div className="flex flex-col gap-3">
                <div className="flex items-end justify-between gap-2">
                    <label className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8A93A6]">
                        preferred formats · pick 1+
                    </label>
                    <span
                        className="font-mono text-[10px] tabular-nums text-[#8A93A6]"
                        data-testid="strategy-formats-count"
                    >
                        {form.formats.length}
                    </span>
                </div>
                <div
                    className="flex flex-wrap gap-2"
                    data-testid="strategy-formats-group"
                >
                    {FORMAT_OPTIONS.map((f) => (
                        <Chip
                            key={f}
                            label={f}
                            selected={form.formats.includes(f)}
                            // No cap on formats — brief says "at least 1".
                            onToggle={() => toggleArrayField("formats", f, 99)}
                            testId={`strategy-format-${f.toLowerCase().replace(/[/\s]+/g, "-")}`}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}
